import React, { useState, useEffect } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import { Button, Modal, Row, Col, Form, OverlayTrigger, Card, Container } from "react-bootstrap";
import { MdEdit, MdAddCircle, MdFilterList, MdDelete } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Tooltip } from '@mui/material';
import loading from "../../assets/images/common/loading.gif";
import { useLocation } from "react-router-dom";
import AppDataGrid from "../../components/common/AppDataGrid";

const Salarycomponent = () => {
    const [salarys, setSalarys] = useState([]);
    const [editId, setEditId] = useState(null);
    const routeLocation = useLocation();
    const [isLoading, setIsLoading] = useState(true);
    const [componenttypes, setComponenttypes] = useState([]);
    const [componentcatgeorys, SetComponentcategorys] = useState([]);
    const [calculationtypes, setCalculationtypes] = useState([]);
    const [calculationbases, SetCalculationbases] = useState([]);
    const [componenttypess, setComponenttypess] = useState([]);
    const [componentcatgeoryss, SetComponentcategoryss] = useState([]);
    const [calculationtypess, setCalculationtypess] = useState([]);
    const [calculationbasess, SetCalculationbasess] = useState([]);
    const [searchQuery, setSearchQuery] = useState("");
    const [showFilterModal, setShowFilterModal] = useState(false);
    const handleCloseFilterModal = () => setShowFilterModal(false);
    // const handleShowFilterModal = () => setShowFilterModal(true);
    const baseUrl = process.env.REACT_APP_API_BASE_URL;
    const navigate = useNavigate();
    const userData = sessionStorage.getItem('user');
    const userObj = JSON.parse(userData);
    const [filter, setFilter] = useState({
        component_code: "",
        component_name: "",
        component_type_id: "",
        component_category_id: "",
        calculation_type_id: "",
        calculation_base_id: "",
        is_statutory: "",
        value: "",
        is_taxable: "",
        affects_pf: "",
        affects_esi: "",
        affects_pt: "",
        affects_gratuity: "",
        display_order: "",
        school_id: "",
        action: "FILTER"
    });
    const [form, setForm] = useState({
        component_code: "",
        component_name: "",
        component_type_id: "",
        component_category_id: "",
        calculation_type_id: "",
        calculation_base_id: "",
        is_statutory: "",
        value: "",
        is_taxable: "",
        affects_pf: "",
        affects_esi: "",
        affects_pt: "",
        affects_gratuity: "",
        display_order: "",
        school_id: "",
        // action: "FILTER"
    });
    useEffect(() => {
        setIsLoading(true);
        fetchData().finally(() => setIsLoading(false));
    }, []);

    const componenttypeData = async () => {
        try {
            const response = await axios.get(baseUrl + "/component-types/", {
                action: "READ",
                school_id: userObj.school_id
            });

            setComponenttypes(response.data);
        } catch (error) {
            console.log("Error fetching data:", error);
        }
    };

    const componentcategoryData = async () => {
        try {
            const response = await axios.get(baseUrl + "/component-category/", {
                action: "READ",
                school_id: userObj.school_id
            });

            SetComponentcategorys(response.data);
        } catch (error) {
            console.log("Error fetching data:", error);
        }
    };

    const calculationtypeData = async () => {
        try {
            const response = await axios.get(baseUrl + "/calculation-type/", {
                action: "READ",
                school_id: userObj.school_id
            });

            setCalculationtypes(response.data);
        } catch (error) {
            console.log("Error fetching data:", error);
        }
    };
    const calculationbaseData = async () => {
        try {
            const response = await axios.get(baseUrl + "/calculation-base/", {
                action: "READ",
                school_id: userObj.school_id
            });

            SetCalculationbases(response.data);
        } catch (error) {
            console.log("Error fetching data:", error);
        }
    };

    const fetchDropdownData = async (endpoint, setter) => {
        try {
            const response = await axios.get(baseUrl + endpoint, { action: 'READ', school_id: userObj.school_id });
            setter(response.data);
        } catch (error) {
            console.error(`Error fetching ${endpoint}:`, error);
        }
    };

    const handleShowFilterModal = () => {
        if (componenttypess.length === 0) {
            fetchDropdownData('/component-types/', setComponenttypess, userObj.school_id);
        }
        if (componentcatgeoryss.length === 0) {
            fetchDropdownData('/component-category/', SetComponentcategoryss, userObj.school_id);
        }
        if (calculationtypess.length === 0) {
            fetchDropdownData('/calculation-type/', setCalculationtypess, userObj.school_id);
        }
        if (calculationbasess.length === 0) {
            fetchDropdownData('/calculation-base/', SetCalculationbasess, userObj.school_id);
        }

        setShowFilterModal(true);
    }

    // const componenttypeDatas = async () => {
    //     try {
    //         const response = await axios.get(baseUrl + "/component-types/", { action: "READ",
    //             school_id: userObj.school_id });

    //         setComponenttypess(response.data);
    //     } catch (error) {
    //         console.log("Error fetching data:", error);
    //     }
    // };

    // const componentcategoryDatas = async () => {
    //             try {
    //                 const response = await axios.get(baseUrl + "/component-category/", { action: "READ",
    //                     school_id: userObj.school_id });

    //                 SetComponentcategoryss(response.data);
    //             } catch (error) {
    //                 console.log("Error fetching data:", error);
    //             }
    //         };

    // const calculationtypeDatas = async () => {
    //             try {
    //                 const response = await axios.get(baseUrl + "/calculation-type/", { action: "READ",
    //                     school_id: userObj.school_id });

    //                 setCalculationtypess(response.data);
    //             } catch (error) {
    //                 console.log("Error fetching data:", error);
    //             }
    //         };
    //         const calculationbaseDatas = async () => {
    //             try {
    //                 const response = await axios.get(baseUrl + "/calculation-base/", { action: "READ",
    //                     school_id: userObj.school_id });

    //                 SetCalculationbasess(response.data);
    //             } catch (error) {
    //                 console.log("Error fetching data:", error);
    //             }
    //         };

    useEffect(() => {
        componenttypeData();
        componentcategoryData();
        calculationtypeData();
        calculationbaseData();
        // componenttypeDatas();
        // componentcategoryDatas();
        //  calculationtypeDatas();
        // calculationbaseDatas();
    }, []);

    const normalizeSalaryData = (salaryData) => ({
        ...salaryData,
        is_taxable: salaryData.is_taxable === "Yes" ? "Y" :
            salaryData.is_taxable === "No" ? "N" :
                salaryData.is_taxable || "",
        is_active: salaryData.is_active === "Active" ? "A" :
            salaryData.is_active === "Inactive" ? "I" :
                salaryData.is_active || "A"

    });

    const handleEditClick = (salary_component_id) => {
        const employeemasterToEdit = salarys.find(
            salary => salary.salary_component_id === salary_component_id
        );

        if (employeemasterToEdit) {
            const normalizedData = normalizeSalaryData(employeemasterToEdit);
            setForm(normalizedData);
            setEditId(salary_component_id);
        } else {
            console.error(`Salary component with ID ${salary_component_id} not found.`);
        }
    };

    const fetchData = async () => {
        try {
            const response = await axios.post(baseUrl + "/salarycomponent/", {
                action: "READ",
                school_id: userObj.school_id
            });

            setSalarys(response.data);
        } catch (error) {
            console.log("Error fetching data:", error);
        }
    };

    const handleDeleteClick = async (salary_component_id) => {
        const confirmDelete = window.confirm('Are you sure you want to change the status?');

        if (!confirmDelete) {
            return;
        }
        const requestBody = {
            salary_component_id: salary_component_id,
            action: "DELETE"
        };

        try {
            const response = await axios.post(baseUrl + '/salarycomponent/', requestBody, {
                headers: {
                    'Content-Type': 'application/json'
                },
            });
            if (response.status < 200 || response.status >= 300) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }
            toast.success("Record Set To InActive ");
            fetchData();
        } catch (error) {
            console.error('Error:', error);
        }
    };

    const searchableColumns = [
        (row) => (row.component_code),
        (row) => (row.component_name),
        (row) => (row.component_type_name),
        (row) => (row.component_category_name),

        (row) => (row.calculation_type_name),
        (row) => (row.calculation_base_name),
        (row) => (row.is_taxable),
        (row) => (row.value),
        (row) => (row.display_order),

        (row) => (row.is_active),
    ];

    const normalizedQuery = (searchQuery || '').toLowerCase().replace(/[-\s]+/g, '');

    const filteredRecords = (salarys || []).filter((item) =>
        searchableColumns.some((selector) => {
            const value = selector(item) ?? "";
            const stringValue = String(value).toLowerCase().replace(/[-\s]+/g, '');
            return stringValue.includes(normalizedQuery);
        })
    );

    const hasRecords = filteredRecords.length > 0;

    const columns = [
        {
            field: "component_name",
            headerName: "Component Name",
            flex: 1,
            renderCell: (params) => {
                const value = params.value || " ";
                return (
                    <Tooltip title={value}>
                        <span className="cell-wrap">
                            {value.length > 13 ? value.substring(0, 13) + "..." : value}
                        </span>
                    </Tooltip>
                );
            },
        },
        {
            field: "component_code",
            headerName: "Component Code",
            flex: 1,
            renderCell: (params) => {
                const value = params.value || " ";
                return (
                    <Tooltip title={value}>
                        <span className="cell-wrap">
                            {value.length > 13 ? value.substring(0, 13) + "..." : value}
                        </span>
                    </Tooltip>
                );
            },
        },
        {
            field: "component_type_name",
            headerName: "Component Type",
            flex: 1,
            renderCell: (params) => {
                const value = params.value || " ";
                return (
                    <Tooltip title={value}>
                        <span className="cell-wrap">
                            {value.length > 13 ? value.substring(0, 13) + "..." : value}
                        </span>
                    </Tooltip>
                );
            },
        },
        {
            field: "component_category_name",
            headerName: "Component Category",
            flex: 1,
            renderCell: (params) => {
                const value = params.value || " ";
                return (
                    <Tooltip title={value}>
                        <span className="cell-wrap">
                            {value.length > 13 ? value.substring(0, 13) + "..." : value}
                        </span>
                    </Tooltip>
                );
            },
        },
        {
            field: "calculation_type_name",
            headerName: "Calculation Type",
            flex: 1,
            renderCell: (params) => (
                <Tooltip title={params.value}>
                    <span className="cell-wrap">{params.value}</span>
                </Tooltip>
            ),
        },
        {
            field: "calculation_base_name",
            headerName: "Calculation Base",
            flex: 1,
            renderCell: (params) => (
                <Tooltip title={params.value}>
                    <span className="cell-wrap">{params.value}</span>
                </Tooltip>
            ),
        },
        {
            field: "value",
            headerName: "Value",
            flex: 1,
            renderCell: (params) => (
                <Tooltip title={params.value}>
                    <span className="cell-wrap">{params.value}</span>
                </Tooltip>
            ),
        },
        {
            field: "is_taxable",
            headerName: "Is Taxable",
            flex: 1,
            renderCell: (params) => (
                <Tooltip title={params.value}>
                    <span className="cell-wrap">{params.value}</span>
                </Tooltip>
            ),
        },
        {
            field: "display_order",
            headerName: "Display Order",
            flex: 1,
            renderCell: (params) => (
                <Tooltip title={params.value}>
                    <span className="cell-wrap">{params.value}</span>
                </Tooltip>
            ),
        },
        {
            field: "is_active",
            headerName: "Status",
            flex: 1,
            renderCell: (params) => (
                <Tooltip title={params.value}>
                    <span className="cell-wrap">{params.value}</span>
                </Tooltip>
            ),
        },
        {
            field: "actions",
            headerName: "Actions",
            flex: 1,
            sortable: false,
            renderCell: (params) =>
                params.row.calculation_type_name !== "No records found" ? (
                    <div className="tableActions">
                        <Tooltip title="Edit" arrow>
                            <span
                                className="commonActionIcons"
                                onClick={() => handleEditClick(params.row.salary_component_id)}
                            >
                                <MdEdit />
                            </span>
                        </Tooltip>
                        <Tooltip title="Delete" arrow>
                            <span
                                className="commonActionIcons"
                                onClick={() => handleDeleteClick(params.row.salary_component_id)}
                            >
                                <MdDelete />
                            </span>
                        </Tooltip>
                    </div>
                ) : null,
        },
    ];

    const handleInputChange = (e) => {
        const { id, value } = e.target;

        setForm((prevForm) => ({
            ...prevForm,
            [id]: value
        }));
    };
    const handleInputChanges = (e) => {
        const { id, value } = e.target;

        setFilter((prevForm) => ({
            ...prevForm,
            [id]: value
        }));
    };


    const handlefSubmit = async (e) => {
        e.preventDefault();

        const formData = {
            component_code: filter.component_code || null,
            component_name: filter.component_name || null,
            component_type_id: filter.component_type_id || null,
            component_category_id: filter.component_category_id || null,
            calculation_type_id: filter.calculation_type_id || null,
            calculation_base_id: filter.calculation_base_id || null,
            is_statutory: filter.is_statutory || null,
            value: filter.value || null,
            is_taxable: filter.is_taxable || null,
            affects_pf: filter.affects_pf || null,
            affects_esi: filter.affects_esi || null,
            affects_pt: filter.affects_pt || null,
            affects_gratuity: filter.affects_gratuity || null,
            display_order: filter.display_order || null,
            school_id: userObj.school_id,
            action: 'FILTER',
        };

        try {
            const response = await axios.post(baseUrl + "/salarycomponent/", formData, {
                headers: {
                    "Content-Type": "application/json",
                },
            });

            const data = response.data;

            if (
                data &&
                typeof data === "object" &&
                data.message === "No data found for action: FILTER"
            ) {
                setSalarys([]);
                setShowFilterModal(false);

            } else if (Array.isArray(data)) {
                setSalarys(data);
                setShowFilterModal(false);
            } else {
                setSalarys([]);
                setShowFilterModal(false);
            }

        } catch (error) {
            console.error("Error fetching filtered data:", error);
            setSalarys([]);
            setShowFilterModal(false);
        }
    };


    const handleResets = async (e) => {
        e.preventDefault();
        setFilter({
            component_code: "",
            component_name: "",
            component_type_id: "",
            component_category_id: "",
            calculation_type_id: "",
            calculation_base_id: "",
            is_statutory: "",
            value: "",
            is_taxable: "",
            affects_pf: "",
            affects_esi: "",
            affects_pt: "",
            affects_gratuity: "",
            display_order: "",
            school_id: ""

        });
        // setEditId(null);
        setShowFilterModal(true);
        fetchData();
    };
    const handleSearchChange = (event) => {
        setSearchQuery(event.target.value);
    };


    const handleSubmit = async (e) => {
        e.preventDefault();

        const formData = {
            component_code: form.component_code,
            component_name: form.component_name,
            component_type_id: form.component_type_id,
            component_category_id: form.component_category_id,
            calculation_type_id: form.calculation_type_id,
            calculation_base_id: form.calculation_base_id || 0,
            value: form.value || 0,
            is_taxable: form.is_taxable,
            display_order: form.display_order,
            school_id: userObj.school_id,
            is_active: form.is_active || "A",
            action: editId !== null ? 'UPDATE' : 'CREATE',
        };

        if (editId !== null) {
            formData.salary_component_id = editId;
        }

        try {
            const response = await axios.post(baseUrl + "/salarycomponent/", formData, {
                headers: {
                    "Content-Type": "application/json",
                },
            });

            if (editId !== null) {
                toast.success("Record Updated Successfully");
                setEditId(null);
            } else {
                toast.success("Record Added Successfully");
            }

            setForm({
                component_code: "",
                component_name: "",
                component_type_id: "",
                component_category_id: "",
                calculation_type_id: "",
                calculation_base_id: "",
                is_statutory: "",
                value: "",
                is_taxable: "",
                affects_pf: "",
                affects_esi: "",
                affects_pt: "",
                affects_gratuity: "",
                display_order: "",
                school_id: "",
            });
            fetchData();
            componentcategoryData();

        } catch (error) {
            console.log("Full error object:", error);

            if (error.response) {
                const { status, data } = error.response;
                const errorMessage = data.error || data.message || "Unexpected error occurred";

                if (status === 409 && errorMessage.includes("Display Order already exists")) {
                    toast.error("Display Order already exists.", { position: "top-right" });
                } else if (status === 410 && errorMessage.includes("Record already exists")) {
                    toast.error("Record already exists.", { position: "top-right" });
                }
                else if (status === 500) {
                    toast.error("Error submitting data: " + errorMessage, { position: "top-right" });
                } else {
                    toast.error("Unexpected error occurred", { position: "top-right" });
                }
            } else {
                toast.error("Error submitting data: " + error.message, { position: "top-right" });
            }
        }
    };

    const isFixed = calculationtypes.some(
        (ct) =>
            String(ct.calculation_type_id) === String(form.calculation_type_id) &&
            ct.calculation_type_name === "Fixed"
    );

    return (
        <div className="pageBody">
            <ToastContainer />
            <div className="d-flex justify-content-between align-items-center">
                <h6 className="commonTableTitle">Salary Component</h6>
                <div>
                    <OverlayTrigger
                        placement="top"
                        overlay={<Tooltip id="tooltip-top">Filter</Tooltip>}
                    >
                        <Button
                            className="secondaryBtn"
                            variant="secondary"
                            onClick={handleShowFilterModal}
                            style={{ marginBottom: "10px" }}
                        >
                            <MdFilterList />
                        </Button>
                    </OverlayTrigger>
                </div>
            </div>

            <Container fluid style={{ paddingLeft: "0px", paddingRight: "0px" }}>
                <Card>
                    <Card.Body>
                        <form onSubmit={handleSubmit}>
                            <Row>
                                <Col xs={12}>
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={12} md={6} lg={4} xxl={2}>
                                    <div className='commonInput'>
                                        <Form.Group>
                                            <Form.Label>
                                                Component Name <span className='requiredStar'>*</span>
                                            </Form.Label>
                                            <Form.Control
                                                required
                                                type="text"
                                                id="component_name"
                                                value={form.component_name}
                                                placeholder="Enter Component Name"
                                                maxLength={30}
                                                onChange={handleInputChange}
                                                onKeyDown={(e) => {
                                                    if (e.key === ' ' && e.target.selectionStart === 0) {
                                                        e.preventDefault();
                                                    }
                                                }}
                                            />
                                        </Form.Group>
                                    </div>
                                </Col>

                                <Col xs={12} md={6} lg={4} xxl={2}>
                                    <div className='commonInput'>
                                        <Form.Group>
                                            <Form.Label>
                                                Component Code <span className='requiredStar'>*</span>
                                            </Form.Label>
                                            <Form.Control
                                                required
                                                type="text"
                                                id="component_code"
                                                value={form.component_code}
                                                placeholder="Enter Component Code"
                                                maxLength={30}
                                                onChange={handleInputChange}
                                                onKeyDown={(e) => {
                                                    if (e.key === ' ' && e.target.selectionStart === 0) {
                                                        e.preventDefault();
                                                    }
                                                }}
                                            />
                                        </Form.Group>
                                    </div>
                                </Col>

                                <Col xs={12} md={6} lg={4} xxl={2}>
                                    <div className="commonInput">
                                        <Form.Group>
                                            <Form.Label>
                                                Component Type<span className="requiredStar">*</span>
                                            </Form.Label>
                                            <select
                                                className="form-select"
                                                required
                                                id="component_type_id"
                                                value={form.component_type_id}
                                                onChange={handleInputChange}
                                            >
                                                <option value="" disabled hidden>Select Component Type</option>
                                                {(componenttypes || [])
                                                    .map((componenttype) => (
                                                        <option key={componenttype.component_type_id} value={componenttype.component_type_id}>
                                                            {componenttype.component_type_name}
                                                        </option>
                                                    ))}
                                            </select>
                                        </Form.Group>
                                    </div>
                                </Col>

                                <Col xs={12} md={6} lg={4} xxl={2}>
                                    <div className="commonInput">
                                        <Form.Group>
                                            <Form.Label>
                                                Component Category<span className="requiredStar">*</span>
                                            </Form.Label>
                                            <select
                                                className="form-select"
                                                required
                                                id="component_category_id"
                                                value={form.component_category_id}
                                                onChange={handleInputChange}
                                            >
                                                <option value="" disabled hidden>Select Component Category</option>
                                                {(componentcatgeorys || [])
                                                    .map((componentcatgeory) => (
                                                        <option key={componentcatgeory.component_category_id} value={componentcatgeory.component_category_id}>
                                                            {componentcatgeory.component_category_name}
                                                        </option>
                                                    ))}
                                            </select>
                                        </Form.Group>
                                    </div>
                                </Col>

                                <Col xs={12} md={6} lg={4} xxl={2}>
                                    <div className="commonInput">
                                        <Form.Group>
                                            <Form.Label>
                                                Calculation Type<span className="requiredStar">*</span>
                                            </Form.Label>
                                            <select
                                                className="form-select"
                                                required
                                                id="calculation_type_id"
                                                value={form.calculation_type_id}
                                                onChange={handleInputChange}
                                            >
                                                <option value="" disabled hidden>Select Calculation Type</option>
                                                {(calculationtypes || []).map((calculationtype) => (
                                                    <option
                                                        key={calculationtype.calculation_type_id}
                                                        value={calculationtype.calculation_type_id}
                                                    >
                                                        {calculationtype.calculation_type_name}
                                                    </option>
                                                ))}
                                            </select>
                                        </Form.Group>
                                    </div>
                                </Col>

                                <Col xs={12} md={6} lg={4} xxl={2}>
                                    <div className="commonInput">
                                        <Form.Group>
                                            <Form.Label>
                                                Calculation Base<span className="requiredStar">*</span>
                                            </Form.Label>
                                            <select
                                                className="form-select"
                                                required
                                                id="calculation_base_id"
                                                value={form.calculation_base_id}
                                                onChange={handleInputChange}
                                                disabled={isFixed}
                                                style={
                                                    isFixed
                                                        ? { backgroundColor: "#e9ecef", cursor: "not-allowed", opacity: 1 }
                                                        : {}
                                                }
                                            >
                                                <option value="" disabled hidden>Select Calculation Base</option>
                                                {(calculationbases || []).map((calculationbase) => (
                                                    <option
                                                        key={calculationbase.calculation_base_id}
                                                        value={calculationbase.calculation_base_id}
                                                    >
                                                        {calculationbase.calculation_base_name}
                                                    </option>
                                                ))}
                                            </select>

                                        </Form.Group>
                                    </div>
                                </Col>

                                <Col xs={12} md={6} lg={4} xxl={2}>
                                    <div className="commonInput">
                                        <Form.Group>
                                            <Form.Label>
                                                Value <span className="requiredStar">*</span>
                                            </Form.Label>
                                            <Form.Control
                                                required
                                                type="text"
                                                id="value"
                                                value={form.value}
                                                placeholder="Enter Value"
                                                maxLength={30}
                                                onChange={handleInputChange}
                                                disabled={isFixed}
                                                style={
                                                    isFixed
                                                        ? { backgroundColor: "#e9ecef", cursor: "not-allowed", opacity: 1 }
                                                        : {}
                                                }
                                                onKeyDown={(e) => {
                                                    if (e.key === " " && e.target.selectionStart === 0) {
                                                        e.preventDefault();
                                                    }
                                                }}
                                            />
                                        </Form.Group>
                                    </div>
                                </Col>

                                <Col xs={12} md={6} lg={4} xxl={2}>
                                    <div className="commonInput">
                                        <Form.Group>
                                            <div style={{ marginLeft: '10px' }}>
                                                <Form.Label>
                                                    Is Taxable <span className="requiredStar">*</span>
                                                </Form.Label>
                                                <div className="d-flex">
                                                    <div className="form-check">
                                                        <input
                                                            className="form-check-input"
                                                            type="radio"
                                                            name="is_taxable"
                                                            id="Yes"
                                                            value="Y"
                                                            onChange={() => setForm(prev => ({ ...prev, is_taxable: "Y" }))}
                                                            checked={form.is_taxable === "Y"}
                                                            required
                                                        />

                                                        <label className="form-check-label" htmlFor="Yes">Yes</label>
                                                    </div>
                                                    <div className="form-check ms-3">
                                                        <input
                                                            className="form-check-input"
                                                            type="radio"
                                                            name="is_taxable"
                                                            id="No"
                                                            value="N"
                                                            onChange={() => setForm(prev => ({ ...prev, is_taxable: "N" }))}
                                                            checked={form.is_taxable === "N"}
                                                        />

                                                        <label className="form-check-label" htmlFor="No">No</label>
                                                    </div>
                                                </div>
                                            </div>
                                        </Form.Group>
                                    </div>
                                </Col>

                                <Col xs={12} md={6} lg={4} xxl={2}>
                                    <div className='commonInput'>
                                        <Form.Group>
                                            <Form.Label>
                                                Display Order <span className='requiredStar'>*</span>
                                            </Form.Label>
                                            <Form.Control
                                                required
                                                type="number"
                                                id="display_order"
                                                value={form.display_order}
                                                placeholder="Enter Display Order"
                                                min="0"
                                                maxLength={30}
                                                onChange={handleInputChange}
                                                onKeyDown={(e) => {

                                                    if (e.key === ' ' && e.target.selectionStart === 0) {
                                                        e.preventDefault();
                                                    }

                                                    if (e.key === '-' || e.key === 'Subtract') {
                                                        e.preventDefault();
                                                    }
                                                    if (e.key.toLowerCase() === 'e') {
                                                        e.preventDefault();
                                                    }
                                                }}
                                            />
                                        </Form.Group>
                                    </div>
                                </Col>

                                <Col
                                    xs="auto"
                                    className="d-flex justify-content-end align-items-center gap-2 ms-auto mt-4"
                                >
                                    <div>
                                        <Button
                                            type="button"
                                            variant="primary"
                                            className="btn-info clearBtn"
                                            onClick={() => {
                                                setForm({
                                                    component_code: "",
                                                    component_name: "",
                                                    component_type_id: "",
                                                    component_category_id: "",
                                                    calculation_type_id: "",
                                                    calculation_base_id: "",
                                                    is_statutory: "",
                                                    value: "",
                                                    is_taxable: "",
                                                    affects_pf: "",
                                                    affects_esi: "",
                                                    affects_pt: "",
                                                    affects_gratuity: "",
                                                    display_order: "",
                                                    school_id: "",
                                                });
                                                setEditId(null);
                                            }}
                                        >
                                            Reset
                                        </Button>
                                    </div>
                                    <div>
                                        <Button
                                            type="submit"
                                            variant="primary"
                                            className="btn-success primaryBtn"
                                        >
                                            {editId ? "Update" : "Submit"}
                                        </Button>
                                    </div>
                                </Col>
                            </Row>
                        </form>
                    </Card.Body>
                </Card>
            </Container>

            <div style={{ marginTop: '10px' }}>
                <div className="commonDataTableHead">
                    <div className="">
                        <div className="d-flex align-items-center" style={{ gap: "10px" }}>
                            <h6 className="commonTableTitle"></h6>
                        </div>
                        <div className="">
                            <input
                                type="text"
                                placeholder="Search..."
                                value={searchQuery}
                                className="searchInput"
                                onChange={handleSearchChange}
                            />
                        </div>
                        <div className="d-flex align-items-center" style={{ gap: 6 }}>
                        </div>
                    </div>
                </div>
            </div>

            <div className="commonTable height100">
                <div className="tableBody">
                    {isLoading ? (
                        <div className="loadingContainer">
                            <img src={loading} alt="Loading..." className="loadingGif" />
                        </div>
                    ) : (
                        <AppDataGrid
                            rows={Array.isArray(filteredRecords) ? filteredRecords : []}  
                            columns={columns}
                            getRowId={(row) => row.salary_component_id}
                            showToolbar={false}
                            pagination
                            pageSizeOptions={[7, 14, 21]}
                            density="compact"
                            maxHeight={300}
                        />
                    )}
                </div>
            </div>

            <Modal show={showFilterModal} onHide={handleCloseFilterModal} className="commonFilterModal">
                <Modal.Header closeButton className="modalHeaderFixed">
                    <Modal.Title>Filter</Modal.Title>
                </Modal.Header>
                <Modal.Body className="modalBodyScrollable">
                    <Row>
                        <Col xs={12}>
                            <div className="commonInput">
                                <Form.Group controlId="levelName">
                                    <Form.Label>Component Code</Form.Label>
                                    <Form.Control
                                        type="text"
                                        id="component_code"
                                        value={filter.component_code}
                                        placeholder="Enter Component Code"
                                        onChange={handleInputChanges}
                                        onKeyDown={(e) => {
                                            if (e.key === ' ' && e.target.selectionStart === 0) {
                                                e.preventDefault();
                                            }
                                        }}
                                        maxLength={30}
                                    />
                                </Form.Group>
                            </div>
                        </Col>
                        <Col xs={12}>
                            <div className="commonInput">
                                <Form.Group controlId="levelName">
                                    <Form.Label>Component Name</Form.Label>
                                    <Form.Control
                                        type="text"
                                        id="component_name"
                                        value={filter.component_name}
                                        placeholder="Enter Component Name"
                                        onChange={handleInputChanges}
                                        onKeyDown={(e) => {
                                            if (e.key === ' ' && e.target.selectionStart === 0) {
                                                e.preventDefault();
                                            }
                                        }}
                                        maxLength={30}
                                    />
                                </Form.Group>
                            </div>
                        </Col>

                        <Col xs={12}>
                            <div className='commonInput'>
                                <Form.Group controlId="month_name">
                                    <Form.Label>Component Type</Form.Label>
                                    <Form.Select
                                        name="component_type_id"
                                        id="component_type_id"
                                        value={filter.component_type_id}
                                        onChange={(e) => setFilter({ ...filter, component_type_id: e.target.value })}>
                                        <option value="" disabled hidden>Select Component Type</option>
                                        {(componenttypess || [])
                                            .map((componenttypes) => (
                                                <option key={componenttypes.component_type_id} value={componenttypes.component_type_id}>
                                                    {componenttypes.component_type_name}
                                                </option>
                                            ))}
                                    </Form.Select>
                                </Form.Group>
                            </div>
                        </Col>
                        <Col xs={12}>
                            <div className='commonInput'>
                                <Form.Group controlId="month_name">
                                    <Form.Label>Component Category</Form.Label>
                                    <Form.Select
                                        name="component_category_id"
                                        id="component_category_id"
                                        value={filter.component_category_id}
                                        onChange={(e) => setFilter({ ...filter, component_category_id: e.target.value })}>
                                        <option value="" disabled hidden>Select Component Category</option>
                                        {(componentcatgeoryss || [])
                                            .map((componentcatgeorys) => (
                                                <option key={componentcatgeorys.component_category_id} value={componentcatgeorys.component_category_id}>
                                                    {componentcatgeorys.component_category_name}
                                                </option>
                                            ))}
                                    </Form.Select>
                                </Form.Group>
                            </div>
                        </Col>
                        <Col xs={12}>
                            <div className='commonInput'>
                                <Form.Group controlId="month_name">
                                    <Form.Label>calculation Type</Form.Label>
                                    <Form.Select
                                        name="calculation_type_id"
                                        id="calculation_type_id"
                                        value={filter.calculation_type_id}
                                        onChange={(e) => setFilter({ ...filter, calculation_type_id: e.target.value })}>
                                        <option value="" disabled hidden>Select Calculation Type</option>
                                        {(calculationtypess || [])
                                            .map((calculationtypes) => (
                                                <option key={calculationtypes.calculation_type_id} value={calculationtypes.calculation_type_id}>
                                                    {calculationtypes.calculation_type_name}
                                                </option>
                                            ))}
                                    </Form.Select>
                                </Form.Group>
                            </div>
                        </Col>

                        <Col xs={12}>
                            <div className='commonInput'>
                                <Form.Group controlId="month_name">
                                    <Form.Label>Calculation Base</Form.Label>
                                    <Form.Select
                                        name="calculation_base_id"
                                        id="calculation_base_id"
                                        value={filter.calculation_base_id}
                                        onChange={(e) => setFilter({ ...filter, calculation_base_id: e.target.value })}>
                                        <option value="" disabled hidden>Select Calculation Base</option>
                                        {(calculationbasess || [])
                                            .map((calculationbases) => (
                                                <option key={calculationbases.calculation_base_id} value={calculationbases.calculation_base_id}>
                                                    {calculationbases.calculation_base_name}
                                                </option>
                                            ))}
                                    </Form.Select>
                                </Form.Group>
                            </div>
                        </Col>
                        <Col xs={12}>
                            <div className="commonInput">
                                <Form.Group controlId="levelName">
                                    <Form.Label>Value</Form.Label>
                                    <Form.Control
                                        type="text"
                                        id="value"
                                        value={filter.value}
                                        placeholder="Enter Value"
                                        onChange={handleInputChanges}
                                        onKeyDown={(e) => {
                                            if (e.key === ' ' && e.target.selectionStart === 0) {
                                                e.preventDefault();
                                            }
                                        }}
                                        maxLength={30}
                                    />
                                </Form.Group>
                            </div>
                        </Col>
                    </Row>
                </Modal.Body>
                <Modal.Footer className="modalFooterFixed">
                    <Button variant="secondary" className="btn-info clearBtn me-2" onClick={handleResets} >
                        Reset
                    </Button>
                    <div>
                        <Button variant="secondary" className="btn-danger secondaryBtn me-2" onClick={() => { handleCloseFilterModal(); }}>
                            Cancel
                        </Button>

                        <Button variant="primary" className="btn-success primaryBtn" onClick={handlefSubmit}>
                            Search
                        </Button>
                    </div>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default Salarycomponent;
